import React from "react";
import { about, links, profile } from "../content";
import { Briefcase, Building, Rocket, Code, Mail, ArrowUpRight } from "./Icons";

const cardIcons = { building: Building, rocket: Rocket };

const About = () => (
  <section id="about" className="section section--ruled">
    <div className="shell">
      <div className="section-head">
        <p className="eyebrow">About</p>
        <h2 className="section-title">
          The urge to take things apart never really left.
        </h2>
      </div>

      <div className="about-grid">
        {/* --- Narrative --- */}
        <div className="prose reveal">
          <p>
            {about.introParts.map(([text, em], i) =>
              em ? (
                <strong key={i}>{text}</strong>
              ) : (
                <React.Fragment key={i}>{text}</React.Fragment>
              )
            )}
          </p>

          <blockquote className="about-quote">
            <Code />
            <p>{about.quote}</p>
          </blockquote>

          {about.story.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}

          <div className="about-focus">
            {about.focus.map((f) => (
              <span key={f}>{f}</span>
            ))}
          </div>
        </div>

        {/* --- Aside: facts and quick context --- */}
        <aside className="about-aside reveal">
          <div className="about-card">
            <div className="about-card__icon">
              <Briefcase />
            </div>
            <div className="about-card__content">
              <p className="about-card__label">At a glance</p>
              <div className="fact-list">
                {about.facts.map((f) => (
                  <div className="fact" key={f.key}>
                    <span className="fact-key">{f.key}</span>
                    <span className="fact-val">{f.val}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {about.cards.map((c) => {
            const Icon = cardIcons[c.icon];
            return (
              <div className="about-card" key={c.label}>
                <div className="about-card__icon">
                  <Icon />
                </div>
                <div className="about-card__content">
                  <p className="about-card__label">{c.label}</p>
                  <p className="about-card__title">
                    {c.title}
                    <span>{c.meta}</span>
                  </p>
                  <p className="about-card__body">{c.body}</p>
                </div>
              </div>
            );
          })}

          <div className="about-card">
            <div className="about-card__icon">
              <Mail />
            </div>
            <div className="about-card__content">
              <p className="about-card__label">Let's connect</p>
              <p className="about-card__body">{about.closing}</p>
              <a className="about-card__link" href={links.email}>
                <ArrowUpRight />
                <span>{profile.email}</span>
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </section>
);

export default About;
